
export class Country {
    public id:number|null;
    public name:string;
    public code:string;
    public continent:string;


    constructor(data:CountryData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.name = "";
            this.code = "";
            this.continent = "";
        }
        else
        {
            this.id = data.id;
            this.name = data.name;
            this.code = data.code;
            this.continent = data.continent;
        }
    }
    public resetToDefaults():void {
        this.id = null;
        this.name = '';
        this.code = '';
        this.continent = '';


    }
}

export type CountryData = {
    id:number|null;
    name:string;
    code:string;
    continent:string;

}